import React from 'react'
import { FileList, Text } from '@pandiafi/components'

import { DocumentLink } from './DocumentLink'
import {
  TDocument,
  TDocumentCategory,
} from '../../../common/validations/document'

import i18n, { Language } from 'i18n/i18n'

export interface DocumentCategoryProps {
  category: TDocumentCategory
  docs: TDocument[]
}

export const DocumentCategoryInfo: React.FC<DocumentCategoryProps> = ({
  category,
  docs,
}) => {
  const lang = i18n.language as Language

  if (!docs.length) {
    return null
  }

  return (
    <section className="mt-14 first:mt-0">
      {category && (
        <Text
          element="h2"
          size="xl"
          weight="medium"
          className="mb-3 min-tablet:mb-6"
        >
          {category.labels[lang]}
        </Text>
      )}
      <FileList>
        {docs.map((document) => (
          <DocumentLink key={document.id} document={document} />
        ))}
      </FileList>
    </section>
  )
}
